<template>
  <v-container class="pa-0" grid-list-md fluid>
    <v-data-iterator
      :items="items_"
      :pagination.sync="pagination"
      :rows-per-page-items="[]"
      :total-items="total"
      content-tag="div"
      content-class="v-layout"
      :no-data-text="loading ? '加载中...': '没有记录'"
      :no-results-text="loading ? '加载中...' : '没有记录'"
      row
      wrap
    >
      <template slot="item" slot-scope="props">
        <v-flex
          class="pa-1"
          xs12
          sm6
          md4
          lg3
        >
          <v-card v-ripple="clickable" @click="onClickCard(props)">
            <v-card-title>
              <span class="title">{{ tdValue(props.item[headers[0].value], headers[0])}}</span>
              <v-spacer></v-spacer>
              <span v-if="headers[0].right">{{tdValue(props.item[headers[0].right.value], headers[0].right)}}</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile :key="header.value + i" v-for="(header, i) in headers.slice(1)">
                <v-list-tile-content>{{header.text}}</v-list-tile-content>
                <v-list-tile-content class="align-start text-xs-left">
                  {{ tdValue(props.item[header.value], header) }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-card-actions>
              <slot name="item-action" :props="props"></slot>
            </v-card-actions>
          </v-card>
        </v-flex>
      </template>
      <template slot="pageText" slot-scope="props">
        <v-layout align-center row>
          <span>{{props.pageStart}} - {{props.pageStop}} 条，共 {{props.itemsLength}} 条</span>
        </v-layout>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
export default {
  name: 'LDataCard',
  props: {
    getData: {
      type: Function
    },
    initPagination: {
      type: Object,
      default: () => ({})
    },
    headers: {
      type: Array,
      default: () => []
    },
    clickable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items_: [],
    total: 0,
    loading: false,
    pagination: {
      rowsPerPage: 10,
      page: 1,
      descending: false
    }
  }),
  computed: {
    tdValue () {
      return (v, header) => {
        let value = v
        if (header.f instanceof Function) {
          value = header.f(v)
        }
        if (value === null || value === undefined) {
          value = ''
        }
        return value
      }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.getData_()
      },
      deep: true
    }
  },
  methods: {
    onClickCard (e) {
      if (this.clickable) {
        this.$emit('click:row', e)
      }
    },
    async getData_ () {
      if (this.getData instanceof Function) {
        this.loading = true
        let {items, amount} = await this.getData({pagination: this.pagination})
        this.items_ = items || []
        this.total = amount || 0
        this.loading = false
      }
    }
  },
  created () {
    this.pagination = Object.assign({}, this.pagination, this.initPagination)
  }
}
</script>

<style scoped>

</style>
